// import adaptive from './adaptive'
export default (Vue) => {
  // Vue.directive('adaptive', adaptive)
}
